import { Layout, Avatar, Menu, Popover, Badge, notification, Button } from 'antd'
import FontIcon from '../components/YhIcon'
import { useHistory } from 'react-router-dom'
import useGlobalModel from '../model/globalModel'
import useNavModel from '../model/navModel'
import { UserOutlined } from '@ant-design/icons'
import { loginServiceAuth2 } from '@/views/login/LoginServiceAuth2'
import { closeWebPage } from '@/utils/utils'
import searchIcon from '@/assets/images/header_search.png'
import messageIcon from '@/assets/images/hearder_message.png'
import { useEffect } from 'react'
import { useMessagewarnlistModel } from '@/views/messagewarn/messagewarnlistModel'
import { IMessagewarnlistDetail } from '@/views/messagewarn/messagewarnlistService'
import { useToastNotification } from '@/hooks/useToastNotification'

const { Header } = Layout

function ScmHeader() {
    const history = useHistory()
    const { user, setUser, searchMsgUnreadNum, unreadNum } = useGlobalModel()
    const { initNav, addNav } = useNavModel(() => [])
    const { handleRead } = useMessagewarnlistModel()

    useEffect(() => {
        searchMsgUnreadNum()
    }, [])

    /**
    * 创建一个系统内部消息提示
    * @param placement
    */
    const openNotification = (detail: IMessagewarnlistDetail) => {
        notification.open({
            message: '',
            description: (
                <>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>
                            【 {detail.subject}】
                        </span>
                        {/* 维修 */}
                        <span>
                            {detail.content}
                        </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'end', marginTop: '10px' }}>
                        {/* <Button
                            type="primary"
                            onClick={async () => {
                                addNav('10-1')
                            }}
                        >
                            所有消息
                        </Button> */}
                        <Button
                            onClick={() => {
                                handleRead(detail)
                                notification.close(detail.id)
                            }}
                        >
                            标记已读
                        </Button>
                        <Button danger
                            onClick={() => {
                                notification.close(detail.id)
                            }}
                        >
                            关闭弹窗
                        </Button>
                    </div>
                </>
            ),
            placement: 'bottomRight',
            duration: 120,
            key: detail.id,
            style: { border: '1px solid rgba(250, 205, 145, 1)', backgroundColor: 'rgba(255, 253, 241, 1)', width: '460px', padding: "10px", fontSize: "12px" },
            closeIcon: <div />,
            onClick: () => { },
        })
        searchMsgUnreadNum?.()
    }

    const { wsRef } = useToastNotification({
        openNotification,
    })

    //退出登录
    const onLogout = () => {
        if (user.loginType === 'account') {
            setUser({ ...user, shopId: '', shopName: '', shopCode: '', token: '' })
            initNav()
            history.push('/login')
            loginServiceAuth2.Logout()
            // loginServiceAuth2.recordAppLogoutInfo(CLIENT_APP_CODE, user.userCode ?? '')
        } else {
            closeWebPage()
        }
    }

    const onClearCache = () => {
        initNav()
    }

    // 菜单项
    const HeaderMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onClearCache}>关闭所有标签</span>
                </Menu.Item>
                {/* <Menu.Divider /> */}
            </Menu>
        )
    }


    const content = (
        <div onClick={() => onLogout()} style={{ cursor: 'pointer', fontSize: '14px', color: 'rgba(0,0,0,0.65)' }}>
            <FontIcon type="icon-tuichu" style={{ marginRight: '3px' }} />
            <span>安全退出</span>
        </div>
    )

    return (
        <Header className="layout-section-header">
            {/* 左侧按钮 */}
            {/* <div className="layout-sider-logo" style={{flex:1}}><img className="layout-sider-logo-img" src={Logo} alt="管理系统Logo" /></div> */}

            {/* <span style={{ fontSize: "22px", fontWeight: "bold", color: "#2db7f5" }}>{user.userName}</span> */}
            {/* 右侧内容 */}
            <div className="header-right" style={{ paddingRight: '15px' }}>
                {/* <Select
                    defaultValue={user.shopId}
                    style={{ width: "250px" }}
                    className="header-right-item"
                    onChange={(value, options) => onShopChang(value, options as ISelectOption)}
                    options={shopDs}
                /> */}
                {/* 设置 */}
                {/* <Dropdown overlay={HeaderMenu} placement="bottomCenter" trigger={['click']}>
                    <Avatar className="header-right-item config-icon" icon={<FontIcon type="icon-shezhi" />} />
                </Dropdown> */}

                {/* <img className="header-img" src={calculatorIcon} /> */}
                <img className="header-img" src={searchIcon} />

                <Badge count={unreadNum} overflowCount={9}>
                    <img
                        className="header-img"
                        style={{ marginRight: '10px' }}
                        src={messageIcon}
                        onClick={() => {
                            addNav('10-1')
                        }}
                    />
                </Badge>
                {/* 登录用户信息 */}
                <Popover content={content}>
                    <span onClick={(e) => e.preventDefault()} className="header-right-item user-info white-space" style={{ marginLeft: '20px' }}>
                        <Avatar size="small" icon={<UserOutlined />} className="user-icon" />
                        <span className="account">{user.userName ?? '未获取到'}</span>
                    </span>
                </Popover>

                {/* 退出登录 */}
                {/* <FontIcon type="icon-tuichu" className="header-right-item logout-icon" onClick={() => onLogout()} /> */}
            </div>
        </Header>
    )
}

export default ScmHeader
